import { EditMileageScreen } from "@/components/screens/settings/EditMileageScreen"
import { useUpdateAndRegenerateReport } from "@/queries/useReport"
import { useNavigate } from "@/router"
import { currentAuthAtom } from "@/state/auth"
import { mileageDraftAtom } from "@/state/draft/mileage"
import { reportFormDraftAtom } from "@/state/report"
import { timeSpentDraftAtom } from "@/state/draft/timeSpent"
import { useAnalytics } from "@/hooks/use-analytics"
import { useAtom, useAtomValue } from "jotai"
import { useEffect } from "react"
import { periodDraftAtom } from "@/state/draft/period"
import { PlainDate } from "@/utils/date"

export default function EditMileagePage() {
	const navigate = useNavigate()
	const auth = useAtomValue(currentAuthAtom)
	const [mileage, setMileage] = useAtom(mileageDraftAtom)
	const [timeSpent, setTimeSpent] = useAtom(timeSpentDraftAtom)
	const { run, generating } = useUpdateAndRegenerateReport()
	const form = useAtomValue(reportFormDraftAtom)
	const analytics = useAnalytics("Edit_Mileage")
	const period = useAtomValue(periodDraftAtom)
	useEffect(() => {
		analytics.sendEvent("Step_TotalMiles__View")
	}, [])
	return (
		<EditMileageScreen
			dateRange={[PlainDate.from(period.range[0]), PlainDate.from(period.range[1])]}
			reportId={auth.reportId}
			mileage={mileage}
			timeSpent={timeSpent}
			onSave={(data) => {
				setMileage(data.mileage)
				setTimeSpent(data.timeSpent)
				analytics.sendEvent("Step_TotalMiles__Save")
				run(form)
			}}
			onSaveLocal={(data) => {
				setMileage(data.mileage)
				setTimeSpent(data.timeSpent)
			}}
			savingInProcess={generating}
		/>
	)
}
